/**
 *  마이페이지 Index
 *
 *  @author  Bruce.Cheong (2026-05-06)
 *  @author  Hyomkim (2026-05-18)
 *
 */

/** External import */
import { useNavigate }                      from    "react-router-dom";

/** Internal import */
import CSS                                  from    "./MyPage.module.css";

import CardContainer                        from    "@/Component/Elements/CardContainer/CardContainer";
import MainTitle                            from    "@/Component/Elements/MainTitle/MainTitle";

import { ReactComponent as IconContract}    from    "./MyPage/img/contract.svg";
import { ReactComponent as IconQnA}         from    "./MyPage/img/qna.svg";
import { ReactComponent as IconFAQ}         from    "./MyPage/img/faq.svg";

import edit_icon from "./MyPage/img/edit_icon.svg";




function MyPage() {
    const navigate = useNavigate();

    /** CardLink 클릭 */
    function hdlClickLinkCard(e: React.MouseEvent<HTMLDivElement>) {
        const target = e.currentTarget;
        const url = target.dataset.url;

        if (url) {
            navigate(url);
        }
    }


    function hdlClickGoToMyInfoPage(){
        navigate("/myInfo");
    }


    return (
        <div className={CSS.MyPage}>
            <MainTitle title="마이페이지" />

            <CardContainer>
                <div className={[CSS.CardLayout, CSS.MyInfoCard].join(" ")}>
                    <div className={CSS.ArticleCardImageWrap}>
                        <IconContract />
                    </div>
                    <h3 
                        className={CSS.Title}
                        onClick={hdlClickGoToMyInfoPage}
                    >
                        홍길동 고객님

                        <span className={CSS.IconCover}>
                            <img src={edit_icon} alt="정보 수정 아이콘" className={CSS.EditIcon} />
                        </span>
                    </h3>
                    {/* <div className={CSS.Content}>
                        ㅇㅇ 스튜디오와 함께한 소중한 추억
                    </div> */}
                </div>
            </CardContainer>

            <CardContainer>
                <div
                    className={[CSS.CardLayout, CSS.LinkCard].join(" ")}
                    data-url={"/paymentHistory"}
                    onClick={hdlClickLinkCard}
                >
                    <div className={CSS.ArticleCardImageWrap}>
                        <IconContract />
                    </div>
                    <div>
                        <h3 className={CSS.Title}>계약서 조회</h3>
                        <div className={CSS.Content}>
                            고객님의 계약 상세 내역 및 계약서를 확인할 수 있습니다.
                        </div>
                    </div>
                </div>
            </CardContainer>

            {/* 
                2026.05.18 김효민

                개발 완료 후 활성화 예정
            */}
            {/* <CardContainer>
                <div
                    className={[CSS.CardLayout, CSS.LinkCard].join(" ")}
                    data-url={"/qnaList"}
                    onClick={hdlClickLinkCard}
                >
                    <div className={CSS.ArticleCardImageWrap}>
                        <IconQnA />
                    </div>
                    <div>
                        <h3 className={CSS.Title}>
                            1:1 문의
                        </h3>
                        <div className={CSS.Content}>
                            스튜디오에 대한 궁금한 점이 있으신가요? 1:1 문의를 통해 언제든지 문의해주세요.
                        </div>
                    </div>
                </div>
            </CardContainer> */}

            {/* 
                2026.05.18 김효민

                개발 완료 후 활성화 예정
            */}
            {/* <CardContainer>
                <div
                    className={[CSS.CardLayout, CSS.LinkCard].join(" ")}
                    data-url={"/faqList"}
                    onClick={hdlClickLinkCard}
                >
                    <div className={CSS.ArticleCardImageWrap}>
                        <IconFAQ />
                    </div>
                    <div>
                        <h3 className={CSS.Title}>
                            자주 묻는 질문(FAQ)
                        </h3>
                        <div className={CSS.Content}>
                            스튜디오 이용에 대한 궁금증을 빠르게 해결하세요.
                        </div>
                    </div>
                </div>
            </CardContainer> */}
        </div>
    );
}

export default MyPage;